import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import HamburgerMenu from 'react-hamburger-menu';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { i18n, getLocale } from 'core/i18n';
import Tools from 'core/tools';
import Format from 'core/format';
import './sideMenu.css';

class SideMenuControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: 1, // role: 0 (主帳號); role: 1 (子帳號);
      menuOpen: false
    };
  }

  componentDidMount() {
    const self = this;
    let user = JSON.parse(sessionStorage.getItem('user'));

    // role: 0 (主帳號); role: 1 (子帳號);
    if (user && (user.role || user.role === 0)) {
      self.setState({
        role: user.role
      });
    }
  }
  
  render() {
    const self = this,
      {
        state,
        props
      } = self,
      {
        role,
        menuOpen
      } = state,
      {
        balanceInfo
      } = props;
    let functionName = window.location.pathname.split('/')[2];
    return (
      <Fragment>
        {/* ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ 側選單大網 ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ */}
        <div className='area-right'>
          <div className='account-balance-text'>{i18n('account_balance')}</div>
          <div className='account-balance'>
            {
              balanceInfo ? (
                <div>
                  {`${balanceInfo.currencyCode} ${(balanceInfo.available || balanceInfo.available >= 0) ? Format.thousandComma(balanceInfo.available) : ''}`}
                </div>
              ) : null
            }
          </div>
          <div className='side-menu-container'>
            <div className='side-menu-title'>{i18n('function_menu')}</div>
            <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Home')}`}>
              <div
                className={functionName === 'Home' ? 'side-menu-currentPage' : ''}
              >
                {/* 首頁 */}
                {i18n('function_home')}
              </div>
            </Link>
            <a rel='noopener noreferrer' href={`http://www.tigerairtw.com/${getLocale()}/about-tigerair/news`} target='_blank'>
              <div>
                {/* 最新消息 */}
                {i18n('function_news')}
              </div>
            </a>
            <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Profile')}`}>
              <div
                className={functionName === 'Profile' ? 'side-menu-currentPage' : ''}
              >
                {/* 我的資料 */}
                {i18n('my_profile')}
              </div>
            </Link>
            {
              role === 0 ? (
                <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Manage')}`}>
                  <div
                    className={functionName === 'Manage' ? 'side-menu-currentPage' : ''}
                  >
                    {/* 帳號管理 */}
                    {i18n('manage_account')}
                  </div>
                </Link>
              ) : null
            }
            {
              role === 0 ? (
                <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Register')}`}>
                  <div
                    className={functionName === 'Register' ? 'side-menu-currentPage' : ''}
                  >
                    {/* 註冊子帳號 */}
                    {i18n('register_sub_agent')}
                  </div>
                </Link>
              ) : null
            }
            {
              role === 0 ? (
                <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Account')}`}>
                  <div
                    className={functionName === 'Account' ? 'side-menu-currentPage' : ''}
                  >
                    {/* 對帳單 */}
                    {i18n('account_list')}
                  </div>
                </Link>
              ) : null
            }
          </div>
        </div>
        {/* ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ 側選單大網 ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ */}

        {/* ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ 側選單小網 ▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼ */}
        <div className='area-right-mobile'>
          <div className='side-menu-container'>
            <div className='side-menu-hamburger'>
              <HamburgerMenu
                isOpen={menuOpen}
                menuClicked={() => {
                  this.setState({
                    menuOpen: !menuOpen
                  });
                }}
                width={18}
                height={15}
                strokeWidth={1}
                rotate={0}
                color='black'
                borderRadius={0}
                animationDuration={0.5}
              />
            </div>
            <SwipeableDrawer
              anchor="right"
              open={menuOpen}
              onClose={() => {
                this.setState({
                  menuOpen: !menuOpen
                });
              }}
              onOpen={() => {
                this.setState({
                  menuOpen: !menuOpen
                });
              }}
            >
              <div className='side-menu-mobile-container'>
                {
                  sessionStorage.getItem('agentName') ? (
                    <div className='user-name'>
                      <span>{`${i18n('hello')},`}</span>
                      <span>{sessionStorage.getItem('agentName')}</span>
                    </div>
                  ) : null
                }
                <div className='account-balance-text'>{i18n('account_balance')}</div>
                {
                  balanceInfo ? (
                    <div className='account-balance'>
                      <div>{balanceInfo.currencyCode}</div>
                      <div>{(balanceInfo.available || balanceInfo.available >= 0) ? Format.thousandComma(balanceInfo.available) : null}</div>
                    </div>
                  ) : null
                }
                <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Home')}`}>
                  <div>
                    {/* 首頁 */}
                    {i18n('function_home')}
                  </div>
                </Link>
                <a rel='noopener noreferrer' href='https://www.tigerairtw.com/zh-tw/about-tigerair/news' target='_blank'>
                  <div>
                    {/* 最新消息 */}
                    {i18n('function_news')}
                  </div>
                </a>
                <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Profile')}`}>
                  <div>
                    {/* 我的資料 */}
                    {i18n('my_profile')}
                  </div>
                </Link>
                {
                  role === 0 ? (
                    <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Manage')}`}>
                      <div>
                        {/* 帳號管理 */}
                        {i18n('manage_account')}
                      </div>
                    </Link>
                  ) : null
                }
                {
                  role === 0 ? (
                    <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Register')}`}>
                      <div>
                        {/* 註冊子帳號 */}
                        {i18n('register_sub_agent')}
                      </div>
                    </Link>
                  ) : null
                }
                {
                  role === 0 ? (
                    <Link to={`${Tools.generateLocaleUrl(getLocale(), '/Account')}`}>
                      <div>
                        {/* 對帳單 */}
                        {i18n('account_list')}
                      </div>
                    </Link>
                  ) : null
                }
              </div>
            </SwipeableDrawer>
          </div>
        </div>
        {/* ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ 側選單小網 ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲ */}
      </Fragment>
    );
  }
}

export default SideMenuControl;